var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gru-table',{attrs:{"resource":_vm.resource,"fields":_vm.fields,"enabledExcel":false,"enabledPrint":false,"primaryKey":'id'}})}
var staticRenderFns = []

export { render, staticRenderFns }